export const MODULES = {
  CONTACTS: 'contacts',
  CONNECTIONS: 'connections',
  GROUPS: 'groups',
  CONNECT_CARDS: 'connect_cards',
  WORKFLOWS: 'workflows',
  VIDEO_NOTES: 'video_notes',
  DR: 'digital_receptionists',
  INTEGRATIONS: 'integrations',
  CALLERS: 'callers',
  GIVING: 'giving',
  BILLING: 'billing',
  CUSTOM_COLUMNS: 'contact_custom_columns',
  MESSAGE_VARIABLES: 'message_variables',
  MESSAGES: 'messages',
  BACKGROUND_CHECKS: 'background_checks',
};

export const ACTIONS = {
  VIEW: 'view',
  MODIFY: 'modify',
  DELETE: 'delete',
};

export const ALL = 'all';
